export const buildInfo = {
  appName: import.meta.env.VITE_APP_NAME || 'SimpleBlue Website Runtime',
  appVersion: import.meta.env.VITE_APP_VERSION || 'local',
  buildTag: import.meta.env.VITE_BUILD_TAG || 'dev',
  buildTime: import.meta.env.VITE_BUILD_TIME || 'unknown',
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'not configured',
  siteHost: import.meta.env.VITE_SITE_HOST || '',
  publicRuntimeUrl: import.meta.env.VITE_PUBLIC_RUNTIME_URL || '',
  mode: import.meta.env.MODE || 'unknown',
};

export function buildInfoTitle() {
  const lines = [
    buildInfo.appName,
    `Version: ${buildInfo.appVersion}`,
    `Build: ${buildInfo.buildTag}`,
    `Built: ${buildInfo.buildTime}`,
    `Mode: ${buildInfo.mode}`,
  ];
  if (buildInfo.apiBaseUrl && buildInfo.apiBaseUrl !== 'not configured') lines.push(`API: ${buildInfo.apiBaseUrl}`);
  if (buildInfo.siteHost) lines.push(`Site host: ${buildInfo.siteHost}`);
  if (buildInfo.publicRuntimeUrl) lines.push(`Runtime: ${buildInfo.publicRuntimeUrl}`);
  return lines.join('\n');
}
